import { atom, useAtom } from "jotai";
import { useEffect } from "react";

const accountsAtom = atom([]);
accountsAtom.debugLabel = "accountsAtom";

export function useAccounts() {
  const [accounts, setAccounts] = useAtom(accountsAtom);

  useEffect(() => {
    async function getAccounts() {
      const res = await fetch("/api/v4/accounts");
      const json = await res.json();
      setAccounts(json.results);
    }
    getAccounts();
  }, [setAccounts]);

  return accounts;
}
